import { formatCurrency } from '~/lib/CurrencyHelpers.js';
import { useState } from 'react';
import PaymentForm from '~/components/payments/PaymentForm.jsx';
import usePublicPostApi from '~/public/lib/usePublicPostApi.js';
import Loading from '~/components/Loading';
import Modal from "~/components/Modal";
import ThemedModal from '~/components/ThemedModal.jsx';
import * as Toast from '~/lib/Toast';

const PayBalance = ({ event, token }) => {
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [paymentSettings, setPaymentSettings] = useState(null);
    const { save: startPayBalance, isSaving: isLoadingPaymentSettings } =
        usePublicPostApi(`/payment/pay-balance`);

    const amountOwed = event.amount_owed;

    if (amountOwed <= 0) {
        return null;
    }

    function onClickPay() {
        if (!showPaymentForm) {
            setShowPaymentForm(true);

            if (!paymentSettings && !isLoadingPaymentSettings) {
                startPayBalance({
                    submissionToken: token,
                    eventId: event.id,
                    url: window?.location?.href || '',
                }).then(settings => {
                    setPaymentSettings(settings);
                }).catch(err => {
                    setShowPaymentForm(false);
                    Toast.error('Failed to load payment settings, please try again');
                });
            }
        } else {
            setShowPaymentForm(false);
        }
    }

    const paymentBtnLabel = `Pay ${formatCurrency(amountOwed)} Now`;

    return (
        <div>
            <button
                type="button"
                onClick={onClickPay}
                className="form-button btn-inverse  w-full sm:w-auto"
            >
                Pay {formatCurrency(amountOwed)}
            </button>

            <ThemedModal
                isOpen={showPaymentForm}
                onClose={() => setShowPaymentForm(false)}
            >
                    <div>
                        <h2 className="mb-4">Pay Balance</h2>
                        {isLoadingPaymentSettings && <Loading />}
                        {!isLoadingPaymentSettings && paymentSettings && (
                            <PaymentForm
                                type="bookingevent-token"
                                id={`${event.id}-${token}`}
                                paymentSettings={paymentSettings}
                                paymentBtnLabel={paymentBtnLabel}
                            />
                        )}
                    </div>
            </ThemedModal>
        </div>
    );
};

export default PayBalance;
